import React from 'react';
import { Cloud, CloudOff, Loader2, Check } from 'lucide-react';

/**
 * Indicador de guardado en la nube
 * Estados: idle, saving, saved, error
 */
const SaveIndicator = ({ status = 'idle', message = '' }) => {
  if (status === 'idle') return null;

  const getIcon = () => {
    switch (status) {
      case 'saving':
        return <Loader2 className="w-4 h-4 animate-spin text-blue-500" />;
      case 'saved':
        return <Check className="w-4 h-4 text-green-500" />;
      case 'error':
        return <CloudOff className="w-4 h-4 text-red-500" />;
      default:
        return <Cloud className="w-4 h-4 text-gray-400" />;
    }
  };

  const getText = () => {
    switch (status) {
      case 'saving':
        return 'Guardando...';
      case 'saved':
        return 'Guardado';
      case 'error':
        return message || 'Error al guardar';
      default:
        return '';
    }
  };

  const getColor = () => {
    switch (status) {
      case 'saving':
        return 'bg-blue-50 border-blue-200 text-blue-700';
      case 'saved':
        return 'bg-green-50 border-green-200 text-green-700';
      case 'error':
        return 'bg-red-50 border-red-200 text-red-700';
      default:
        return 'bg-gray-50 border-gray-200 text-gray-700';
    }
  };

  return (
    <div
      className={`fixed bottom-4 right-4 flex items-center gap-2 px-4 py-2 rounded-lg border-2 shadow-lg transition-all duration-300 ${getColor()}`}
    >
      {getIcon()}
      <span className="text-sm font-semibold">{getText()}</span>
    </div>
  );
};

export default SaveIndicator;
